import { Injectable } from '@nestjs/common';
import { CommonResponseModel } from '@needle-management/shared-models';
import { StockInDto } from './dto/stock-in.dto';
import { ReportingEntity } from './entities/reporting.entity';
import { StockInEntity } from './entities/stock-in.entity';
import { Between, DataSource } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { StockOutEntity } from './entities/stock-out.entity';
import { StockOutDto } from './dto/stock-out.dto';
import { StockInRepository } from './repositories/stock-in.repository';
import { StatusEnum } from '@needle-management/shared-models';
import { MaterialRequestEntity } from '../material-request/material-request-entity';
import { MaterialRequestRepository } from '../material-request/material-request-repo';
import { GenericTransactionManager } from "../../../typeorm-transactions";


@Injectable()
export class StockInService {
    constructor(
        @InjectRepository(StockInEntity)
        private readonly stockInRepo: Repository<StockInEntity>,

        @InjectRepository(ReportingEntity)
        private readonly reportingRepo: Repository<ReportingEntity>,
        private StockInRepository: StockInRepository,

        @InjectRepository(StockOutEntity)
        private readonly stockOutRepo: Repository<StockOutEntity>,
        private  materialReqRepo: MaterialRequestRepository,

        private readonly dataSource: DataSource,

    ) { }

    async stockIn(req: StockInDto): Promise<CommonResponseModel> {
        try {
            let data = new ReportingEntity;
            data.modelId = req.modelId
            data.pointTypeId = req.pointTypeId
            data.sizeId = req.sizeId
            data.quantity = req.quantity
            data.createdUser = "Admin"
            data.stockId = 0
            data.machineId = req.machineId


            let saveReport = await this.reportingRepo.save(data);
            let checkExistingStock = await this.stockInRepo.findOne({ where: { modelId: req.modelId, sizeId: req.sizeId, pointTypeId: req.pointTypeId } });
            console.log(checkExistingStock)
            if (checkExistingStock?.id > 0) {
                let updateStock = await this.stockInRepo.update({ id: checkExistingStock.id }, { quantity: () => `quantity + ${req.quantity}` });
                let updateStockId = await this.reportingRepo.update({ id: saveReport.id }, { stockId: checkExistingStock.id });
                if (updateStockId && updateStock) {
                    return new CommonResponseModel(true, 1, "Stock Reported successfully. ", updateStock)
                }
                else {
                    return new CommonResponseModel(false, 0, "Something went wrong. ", updateStock)
                }
            }
            else {
                let stockReq = new StockInEntity
                stockReq.modelId = req.modelId
                stockReq.pointTypeId = req.pointTypeId
                stockReq.sizeId = req.sizeId
                stockReq.quantity = req.quantity
                stockReq.createdUser = "Admin"
                stockReq.machineId = req.machineId

                let saveStock = await this.stockInRepo.save(stockReq);
                let updateStockId = await this.reportingRepo.update({ id: saveReport.id }, { stockId: saveStock.id });
                if (saveStock && updateStockId) {
                    return new CommonResponseModel(true, 1, "Stock Reported successfully. ", saveStock)
                }
                else {
                    return new CommonResponseModel(false, 0, "Something went wrong. ", saveStock)
                }
            }
        } catch (error) {
            return error;
        }
    }
    async getStockReported(): Promise<CommonResponseModel> {
        try {
            let reportedStock = await this.reportingRepo.find();
            if (reportedStock.length > 0) {
                return new CommonResponseModel(true, 1, "retrived report successfully. ", reportedStock)
            }
            else {
                return new CommonResponseModel(false, 0, "Something went wrong. ",)
            }
        } catch (error) {
            return error;
        }
    }

    async getStock(): Promise<CommonResponseModel> {
        try {
            let query = 'Select m.*,s.*,nm.*,ns.*,pt.*,(s.quantity-s.issued_quantity) as stockQty,s.id AS id from stock_in s left join machines m on m.id = s.machine_id left join needle_model nm on nm.id = s.model_id left join needle_sizes ns on ns.id = s.size_id left join point_types pt on pt.id = s.point_type_id having s.quantity-s.issued_quantity > 0';
            let stock = await this.stockInRepo.query(query);
            if (stock.length > 0) {
                return new CommonResponseModel(true, 1, "retrived report successfully. ", stock)
            }
            else {
                return new CommonResponseModel(false, 0, "Something went wrong. ",)
            }
        } catch (error) {
            return error;
        }
    }

    async getAllStockOut(req: any): Promise<CommonResponseModel> {
        const { fromDate, toDate } = req;
        try {
            let query = `
        SELECT
            so.id,
            m.machine_type AS machineType,
            m.machine AS machineSerialNo,
            nm.needle_model AS needleModel,
            pt.point_type AS needlePoint,
            ns.needle_sizes AS size,
            si.quantity AS quantity,
            so.issued_at AS issuedAt,
            so.issued_by AS issuedBy,
            so.issued_to AS issuedTo,
            so.module_no AS moduleNo,
            so.shift AS shift,
            s.style AS style,so.job_no AS jobNo
        FROM stock_out so
        LEFT JOIN stock_in si ON si.id = so.stock_id
        LEFT JOIN machines_needle_mapping mnp ON mnp.needle_model_id = si.model_id
        LEFT JOIN machines m ON m.id = mnp.machines_id
        LEFT JOIN style s ON s.id = mnp.styles_id
        LEFT JOIN needle_sizes ns ON ns.id = si.size_id
        LEFT JOIN point_types pt ON pt.id = mnp.needle_point_type_id
        LEFT JOIN needle_model nm ON nm.id = mnp.needle_model_id `;

            if (fromDate && toDate) {
                query += ` WHERE DATE(so.created_at) BETWEEN '${fromDate}' AND '${toDate}' `;
            }
            query += `GROUP BY so.id`
            const data = await this.stockInRepo.query(query);
            if (data.length > 0) {
                return new CommonResponseModel(true, 1, "Data retrieved successfully", data);
            } else {
                return new CommonResponseModel(true, 1, "No Data Found", []);
            }
        } catch (error) {
            console.error('Error executing query:', error);
        }


    }


    async getStockInfoByDateRange(req: { startDate: Date, endDate: Date }): Promise<CommonResponseModel> {
        const { startDate, endDate } = req;
        try {
            // const stock = await this.StockInRepository.find({
            //     where: {
            //         createdAt: Between(startDate, endDate),
            //     },
            //     order: {
            //         createdAt: 'DESC',
            //     }
            // });
            const stock = await this.StockInRepository.getStockInfoByDateRange(startDate, endDate)
            console.log(stock)
            if (stock.length > 0) {
                return new CommonResponseModel(true, 1, "Stock-In Report Retrieved Succesfully.", stock);
            } else {
                return new CommonResponseModel(true, 0, "No records found in the given date range.");
            }
        } catch (error) {
            return new CommonResponseModel(false, 0, "An error occurred.", error);
        }
    }


    async stockOut(req: StockOutDto): Promise<CommonResponseModel> {
        const manager = new GenericTransactionManager(this.dataSource);
        try {
            await manager.startTransaction();
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            if (CurrentMonth < 4) {
                fromDate = (CurrentYear - 1);
                toDate = (CurrentYear);
            } else {
                fromDate = (CurrentYear);
                toDate = (CurrentYear + 1);
            }
            const query = 'select count(*) as cnt from stock_out';
            let totalJobs = await this.stockOutRepo.query(query)
            let val = totalJobs[0].cnt + 1;


            let refNo = val + "";
            let jobNo = "JOB/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

            console.log(req)
            let data = new StockOutEntity;
            data.styleId = req.styleId
            data.issuedAt = req.issuedAt
            data.issuedBy = req.issuedBy
            data.issuedQuantity = req.issuedQuantity
            data.issuedTo = req.issuedTo
            data.jobNo = jobNo
            data.moduleNo = req.moduleNo
            data.shift = req.shift
            data.stockId = req.stockId
            data.createdUser = "admin"
            data.requestId = req.id
            let saveReport = await this.stockOutRepo.save(data);
            // console.log(saveReport)
            let updateFlag = true
            let requestUpdateFlag = true

            if(saveReport){
                let updateIssuedQty = await this.stockInRepo.update({id:req.stockId},{issuedQuantity : () => `issued_quantity + ${req.issuedQuantity}`})
                if(!updateIssuedQty.affected){
                    updateFlag = false
                }
                let status = StatusEnum.Completed
                let query = "select sum(issued_quantity) AS totalIssued from stock_out where request_id = "+req.id
                let getTotalIssued = await this.stockOutRepo.query(query);
                let getRequestQty = await this.materialReqRepo.findOne({where:{materialReqId:req.id}});
                let pendingQty = Number(getRequestQty.needleQuantity) - Number(getTotalIssued[0].totalIssued) - Number(req.issuedQuantity);
                if(pendingQty > 0){
                    status = StatusEnum.PartiallyIssued
                }
                let updateMaterialRequest = await this.materialReqRepo.update({materialReqId:req.id},{stockInId:req.id,status:status})
                if(!updateMaterialRequest.affected){
                    requestUpdateFlag = false
                }
            }
            
            if(saveReport && updateFlag && requestUpdateFlag){
                await manager.completeTransaction();
                
                return new CommonResponseModel(true,1,"Stock Out successfully. ", saveReport)
            }
            else {
                await manager.releaseTransaction();

                return new CommonResponseModel(false, 0, "Something went wrong. ", saveReport)
            }
        } catch (error) {
            await manager.releaseTransaction();

            return new CommonResponseModel(false, 0, "Something went wrong. ", error)
        }
    }
}
